module.exports = __webpack_public_path__ + "media/images/drop-call-icon-popup-92eb90ae8dd40c5f09ebb2ad18400b944c3d8d22dda36783192ebbca63dd2b58.svg";